<template>
  <div
    id="ld-content"
    class="ld-edit"
    :class="{'is-firefox': isFirefox, 'again': isClicked}"
  >
    <p class="warn-area">
      <svg class="warning-icon">
        <use xlink:href="#warn" />
      </svg>
      {{ $t(section) }}
      <a
        v-if="isFirefox"
        href="/firefox-config.html"
        target="_blank"
      > {{ $t('了解如何设置') }}</a>
    </p>
    <div class="img-area">
      <img
        class="tool-icon"
        src="./images/tool-icon.svg"
        :alt="$t('图标')"
      >
      <p class="img-title color-section">
        {{ $t('zBox WebTool插件') }}
      </p>
    </div>
    <p class="color-section marb4">
      {{ $t('1.下载已经自动开启，如未开始，') }}<a
        id="RE_DOWNLOAD"
        @click="download"
      >{{ $t('点击此处重试') }}</a>
    </p>
    <p class="color-section marb4">
      {{ $t('2.下载完成后，请双击安装程序，按照说明继续操作') }}
    </p>
    <p class="color-section marb4">
      {{ $t('3.完成安装程序后，点击继续') }}
    </p>
    <div class="footer">
      <button
        class="default close c-btn"
        @click="cancel"
      >
        {{ $t('取消') }}
      </button>
      <button
        class="primary continue s-btn"
        @click="goOn"
      >
        {{ $t('继续') }}
      </button>
    </div>
  </div>
</template>
<script>
import _$ from 'js/api/getdata.js'
import { isMacOs } from 'js/util/util.js'

export default {
  data() {
    return {
      isClicked: false,
      title: this.$t('安装zBox WebTool插件'),
    }
  },
  computed: {
    isFirefox() {
      return /Firefox/.test(window.navigator.userAgent)
    },
    section() {
      if (this.isFirefox) {
        return this.$t('在该电脑上未检测到插件zBox WebTool，请重试安装或检查 Firefox浏览器设置。')
      }
      return this.$t('未检测到插件zBox WebTool，请重试安装')
    },
    isMacOs() {
      return isMacOs()
    },
  },
  methods: {
    /**
         * 继续
         */
    goOn() {
      this.isClicked = true
      this.$emit('retry')
    },
    cancel() {
      this.$emit('closeParentDialog')
    },
    download() {
      let url = ''
      if(isLinux()){
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.deb'
      } else if(isMacOs()) {
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.dmg'
      } else{
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.exe'
      }
      window.open(url, '_self')
      this.$emit('after-download')
    },
  },
}
</script>
<style lang="less">
@import '~less/ldtool-dialog.less';
</style>
